import { createContext } from "react";
import IQBPaymentCard from "../models/IQBPaymentCard";
import IQBPaymentsDetails from "../models/IQBPaymentsDetails";

export interface IQbPaymentContextModel {
    setExistingCard: (value: IQBPaymentCard) => void;
    existingCard?: IQBPaymentCard;
    newPaymentDetails?: IQBPaymentsDetails;
    isLoading: boolean;
    setIsLoading: (value: boolean) => void;
    nextSlide: () => void;
    prevSlide: () => void;
}

export const QbPaymentContext = createContext<IQbPaymentContextModel>({});
